import { Container, FormControl, FormControlLabel, Grid, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import { Stack } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { init, search, selectEvaluationKind } from "../../redux/actions/evaluationImplement";
import Header from "../common/Header";

export default function EvaluationImplement() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const columns = [
    {
      field: "radiobutton",
      headerName: "  ",
      width: 40,
      editable: true,
      headerClassName: "headerColor",
      renderCell: params => <Radio checked={radioChecked[0] === params.id} value={params.id} />
    },
    {
      field: "serialNumber",
      headerName: "通し番号",
      width: 150,
      editable: true,
      headerClassName: "headerColor",
      flex: 0.5
    },
    { field: "grade", headerName: "年", width: 50, editable: true, headerClassName: "headerColor", flex: 0.5 },
    { field: "class", headerName: "組", width: 50, editable: true, headerClassName: "headerColor", flex: 0.5 },
    { field: "number", headerName: "番", width: 50, editable: true, headerClassName: "headerColor", flex: 0.5 },
    { field: "name", headerName: "生徒氏名", width: 210, editable: true, headerClassName: "headerColor", flex: 1 },
    {
      field: "evaluationImplement",
      headerName: "評価実施",
      width: 191,
      editable: true,
      headerClassName: "headerColor",
      flex: 0.5
    }
  ];

  const [gridData, setGridData] = useState([]);

  const dispatch = useDispatch();
  const evaluationList = useSelector(state => state.evaluationImplement.evaluationList);
  const evaluationTerm = useSelector(state => state.evaluationImplement.evaluationTerms);
  const rows = useSelector(state => state.evaluationImplement.rows);
  const listId = useSelector(state => state.evaluationImplement.listId);
  const termId = useSelector(state => state.evaluationImplement.termId);
  const selcetEvaluationMethod = useSelector(state => state.evaluationImplement.evaluationKind);

  let radioChecked = [1];
  const [selectionModel, setSelectionModel] = React.useState(radioChecked);
  radioChecked = selectionModel;
  const selectedRow = gridData.filter(item => {
    return item.id === selectionModel[0];
  });

  useEffect(
    () => {
      dispatch(init());
    },
    [dispatch]
  );

  useEffect(
    () => {
      setGridData(rows);
    },
    [rows]
  );
  const searchSubmit = request => {
    dispatch(
      search({
        ...request,
        listId: request.listId ? request.listId : "",
        termId: request.termId ? request.termId : "",
        implementationFlg: request.implementationFlg ? request.implementationFlg : ""
      })
    );
  };
  const handleRadioChange = event => {
    const selectedValue = event.target.value;
    dispatch(selectEvaluationKind(selectedValue));
  };

  const submitEvaluationPage = () => {
    if (selectedRow.length !== 0 && selectedRow[0].serialNumber) {
      if (selcetEvaluationMethod === "selectByProject") {
        const params = selectedRow.map(
          row =>
            `?serialNumber=${row.serialNumber}&grade=${row.grade}&classNumber=${row.class}&number=${row.number}&name=${row.name}&listId=${listId}&termId=${termId}`
        );
        window.location.href = "/WebEvaluation1" + params;
      } else if (selcetEvaluationMethod === "selectByList") {
        const params = selectedRow.map(row => `?serialNumber=${row.serialNumber}&listId=${listId}&termId=${termId}`);
        window.location.href = "/WebEvaluation2" + params;
      }
    } else {
      alert("生徒を1人だけ選択してください。");
    }
  };

  return (
    <Box>
      <Header />
      <Container maxWidth="xl">
        <Box
          sx={{
            marginTop: 4,

            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h3" variant="h7" align="left">
            評価実施
          </Typography>
        </Box>

        <Box
          sx={{
            margin: 2,
            align: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h4" variant="h7" align="left">
            いずれか入力された内容で検索します
          </Typography>
        </Box>
        <Box
          sx={{
            m: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box
            sx={{
              mt: 1,
              alignItems: "left",
              justifyContent: "left"
            }}
          >
            <Grid container sx={{flexGrow: 1}} spacing={1} alignItems={"flex-start"} justifyContent={"flex-start"} textAlign={"left"}>

              <Grid item xs={4} lg={3} mt={1} justifyContent={"left"}>
                <FormControl sx={{ mr: 3, ml: 5 }}>
                  <Typography variant="h7" align="left">
                    通し番号
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9} mt={1}>
                <FormControl>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    sx={{ background: "white" }}
                    style={{ width: "300px" }}
                    {...register("serialNumber", {
                      pattern: { value: /^[0-9]+$/, message: "通し番号は数字で入力してください。" }
                    })}
                  />
                  {errors.serialNumber &&
                    <span className="error-msg">
                      {errors.serialNumber.message} <br />
                    </span>}
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={3} justifyContent={"left"}>
                <FormControl sx={{ mr: 3, ml: 5 }}>
                  <Typography variant="h7" align="left">
                    学年
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9}>
                <FormControl>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    sx={{ background: "white" }}
                    style={{ width: "300px" }}
                    {...register("grade", {
                      pattern: { value: /^[0-9]+$/, message: "学年は数字で入力してください。" }
                    })}
                  />
                  {errors.grade &&
                    <span className="error-msg">
                      {errors.grade.message}
                    </span>}
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={3} justifyContent={"left"}>
                <FormControl sx={{ mr: 3, ml: 5 }}>
                  <Typography variant="h7" align="left">
                    クラス
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9}>
                <FormControl>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    sx={{ background: "white" }}
                    style={{ width: "300px" }}
                    {...register("class", {
                      pattern: { value: /^[0-9]+$/, message: "クラスは数字で入力してください。" }
                    })}
                  />
                  {errors.class &&
                    <span className="error-msg">
                      {errors.class.message}
                    </span>}
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={3} justifyContent={"left"}>
                <FormControl sx={{ mr: 3, ml: 5 }}>
                  <Typography variant="h7" align="left">
                    番号
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9}>
                <FormControl>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    sx={{ background: "white" }}
                    style={{ width: "300px" }}
                    {...register("number", {
                      pattern: { value: /^[0-9]+$/, message: "番号は数字で入力してください。" }
                    })}
                  />
                  {errors.number &&
                    <span className="error-msg">
                      {errors.number.message}
                    </span>}
                </FormControl>
              </Grid>

              <Grid item xs={4} lg={3} justifyContent={"left"}>
                <FormControl sx={{ mr: 3, ml: 5 }}>
                  <Typography variant="h7" align="left">
                    氏名
                  </Typography>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={9}>
                <FormControl>
                  <TextField
                    id="outlined-basic"
                    size="small"
                    variant="outlined"
                    sx={{ background: "white" }}
                    style={{ width: "300px" }}
                    {...register("name")}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{
              margin: 2,
              ml: 10,
              align: "center",
              justifyContent: "center"
            }}
          >
            <Typography component="h4" variant="h7" align="left">
              評価内容
            </Typography>
          </Box>

          <Box
            sx={{
              ml: 5,
              mr: 10,
              display: "flex",
              flexDirection: "column",
              bgcolor: "#FFFFFF",
              border: "1.5px solid black"
            }}
          >
            <FormControl
              sx={{
                ml: 1
              }}
            >
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                {evaluationList.map(list =>
                  <FormControlLabel
                    key={list.listId}
                    value={list.listId}
                    control={<Radio />}
                    label={list.listName}
                    {...register("listId")}
                  />
                )}
              </RadioGroup>
            </FormControl>
          </Box>

          <Box
            sx={{
              margin: 2,
              ml: 10,
              align: "center",
              justifyContent: "center"
            }}
          >
            <Typography component="h4" variant="h7" align="left">
              評価時期
            </Typography>
          </Box>

          <Box
            sx={{
              ml: 5,
              mr: 10,
              display: "flex",
              flexDirection: "column",
              bgcolor: "#FFFFFF",
              border: "1.5px solid black"
            }}
          >
            <FormControl
              sx={{
                ml: 1
              }}
            >
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                {evaluationTerm.map(term =>
                  <FormControlLabel
                    key={term.termId}
                    value={term.termId}
                    control={<Radio />}
                    label={term.termName}
                    {...register("termId")}
                  />
                )}
              </RadioGroup>
            </FormControl>
          </Box>

          <Box
            sx={{
              margin: 2,
              ml: 10,
              align: "center",
              justifyContent: "center"
            }}
          >
            <Typography component="h4" variant="h7" align="left">
              評価実施状態
            </Typography>
          </Box>

          <Box
            sx={{
              ml: 5,
              mr: 10,
              display: "flex",
              flexDirection: "column",
              bgcolor: "#FFFFFF",
              border: "1.5px solid black"
            }}
          >
            <FormControl
              sx={{
                ml: 1
              }}
            >
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
              >
                <FormControlLabel value="1" control={<Radio />} label="済" {...register("implementationFlg")} />
                <FormControlLabel value="0" control={<Radio />} label="未" {...register("implementationFlg")} />
              </RadioGroup>
            </FormControl>
          </Box>
          <Box
            sx={{
              ml: 5,
              mr: 10
            }}
          >
            <FormControl
              sx={{
                m: 2
              }}
            />
          </Box>
        </Box>

        <Container maxWidth="sm">
          <Stack sx={{ mr: 7 }} direction="row" spacing={5} justifyContent="center" paddingBottom={2}>
            <Button variant="contained" sx={{ bgcolor: "#82b1ff", width: "50%" }} onClick={handleSubmit(searchSubmit)}>
              検索
            </Button>
          </Stack>
        </Container>

        <Box
          sx={{
            margin: 2,
            marginTop: 2,
            align: "center",
            justifyContent: "center"
          }}
        >
          <Typography component="h4" variant="h7" align="left">
            評価したい生徒を選択してください
          </Typography>
        </Box>
        <Box
          sx={{
            m: 2,
            display: "flex",
            flexDirection: "column",
            bgcolor: "#fff9c4"
          }}
        >
          <Box sx={{ alignItems: "center", justifyContent: "center", m: 3 }}>
            <Container maxWidth="xl">
              <div
                style={{
                  height: 330,
                  width: "95%",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <DataGrid
                  sx={{
                    bgcolor: "white",
                    " .headerColor": {
                      backgroundColor: "#ffcc80"
                    }
                  }}
                  rows={gridData}
                  columns={columns}
                  experimentalFeatures={{ newEditingApi: true }}
                  selectionModel={selectionModel}
                  onSelectionModelChange={newSelectionModel => {
                    setSelectionModel(newSelectionModel);
                  }}
                  localeText={{
                    noRowsLabel: "ロールはありません"
                  }}
                />
              </div>
            </Container>
          </Box>

          <Box
            sx={{
              margin: 2,
              ml: 10,
              align: "center",
              justifyContent: "center"
            }}
          >
            <Typography component="h4" variant="h7" align="left">
              評価方法
            </Typography>
          </Box>

          <Box
            sx={{
              ml: 5,
              mr: 10,
              display: "flex",
              flexDirection: "column",
              bgcolor: "#FFFFFF",
              border: "1.5px solid black"
            }}
          >
            <FormControl
              sx={{
                ml: 1
              }}
            >
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                onChange={handleRadioChange}
              >
                <FormControlLabel value="selectByProject" control={<Radio />} label="項目ごとにカードを選択" />
                <FormControlLabel value="selectByList" control={<Radio />} label="一覧で評価等級を選択" />
              </RadioGroup>
            </FormControl>
          </Box>

          <Box
            sx={{
              ml: 5,
              mr: 10
            }}
          >
            <FormControl
              sx={{
                m: 2
              }}
            />
          </Box>
        </Box>

        <Container maxWidth="sm">
          <Stack sx={{ mr: 7 }} direction="row" spacing={5} justifyContent="center">
            <Button variant="contained" sx={{ bgcolor: "#82b1ff", width: "50%" }} onClick={submitEvaluationPage}>
              決定
            </Button>
          </Stack>
        </Container>

        <Box sx={{alignItems: "right", justifyContent: "right", display: "flex", m: 2}}>
          <Button type="submit" href="StaffMenu" variant="contained" size="medium" sx={{ bgcolor: "#82b1ff", marginLeft: "auto" }}>
            戻る
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
